import React, { useState } from 'react'
import { useDispatch } from 'react-redux';
import { login } from './features/userSlice';
import { auth } from './firebase';
import './Login.css'

function Login() {
    const [email, setEmal] = useState();
    const [password, setPassword] = useState();
    const [name, setName] = useState();
    const [profilePic, setProfilePic] = useState();
    const dispatch = useDispatch();

    const logintoApp = (e) => {
        e.preventDefault();

        auth.signInWithEmailAndPassword(email, password).then(userAuth => {
            dispatch(login({
                email: userAuth.user.email,
                uid: userAuth.user.uid,
                displayName: userAuth.user.displayName,
                profileUrl: userAuth.user.photoURL,
            }))
        }).catch((error) => alert(error));
    }
    const register = () => {
        if(!name){
            return alert('Please enter a full name');
        }
        auth.createUserWithEmailAndPassword(email, password).then((userAuth) => {
            userAuth.user.updateProfile({
                displayName: name,
                photoUrl: profilePic,
            })
            .then(() => {
                dispatch(login({
                    email: userAuth.user.email,
                    uid: userAuth.user.id,
                    displayName: name,
                    photoUrl: profilePic
                }))
            })
        }).catch(error => alert(error.message));
    };

  return (
    <div className='login'>
        <center><img src='https://abrhsp.org.br/wp-content/uploads/2018/05/2000px-LinkedIn_Logo.svg_.png' alt=''/></center>

        
        <form>
            <input value={name} onChange={e => setName(e.target.value)} type='text' placeholder='Full name (required if regestering)'/>
            <input value={profilePic} onChange={e => setProfilePic(e.target.value)} type='text' placeholder='Profile pic URL (optional)'/>
            <input value={email} onChange={e => setEmal(e.target.value)} type='email' placeholder='nzolakiampava@gmail.com' />
            <input value={password} onChange={e => setPassword(e.target.value)} type='password' placeholder='Password' />

            <button type='submit' onClick={logintoApp}>Sign In</button>
        </form>

        <p>
            Not a memeber?{(" ")}
            <span className='login__register' onClick={register}>Register Now</span>
        </p>
    </div>
  )
}

export default Login
